import React from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InfoIconWithTooltip from '../../BuildingBlocks/InfoIconWithTooltip';

const useStyles = makeStyles((theme: any) => ({
  marginLeftAuto: {
    marginLeft: 'auto',
  },
  tileRoot: {
    backgroundColor: theme.palette.brand.white,
    padding: theme.spacing(3),
    paddingTop: theme.spacing(2.5),
    paddingRight: theme.spacing(2),
    borderRadius: theme.spacing(1.5),
    border: '2px solid rgba(0, 0, 0, 0.08)',
    position: 'relative',
  },
  tileTitle: {
    lineHeight: 1.25,
  },
  tileValue: {
    marginTop: theme.spacing(3),
    lineHeight: `${theme.spacing(3)}px`,
    fontSize: ({ hasError }: any) =>
      hasError ? theme.spacing(2.5) : undefined,
    fontWeight: ({ hasError }: any) => (hasError ? 400 : undefined),
  },
  unitsLabel: {
    fontSize: 20,
    color: theme.palette.brand.grey,
    marginLeft: theme.spacing(0.5),
    lineHeight: 0,
  },
}));

interface Props {
  title: string;
  value: string;
  isLoading: boolean;
  helpText?: string;
  hasError?: boolean;
  unit?: string;
}

export default function AnalyticsTile({
  title,
  value,
  isLoading,
  helpText,
  hasError = false,
  unit,
}: Props) {
  const classes = useStyles({ hasError });
  return (
    <div className={classes.tileRoot}>
      <Grid container direction="row-reverse" justifyContent="flex-end">
        {helpText && (
          <div className={classes.marginLeftAuto}>
            <InfoIconWithTooltip helpText={helpText} />
          </div>
        )}
        <Typography variant="h6" className={classes.tileTitle}>
          {title}
        </Typography>
      </Grid>
      {isLoading && <CircularProgress />}
      {!isLoading && (
        <Typography variant="h2" className={classes.tileValue}>
          {value}
          {unit && <span className={classes.unitsLabel}>{unit}</span>}
        </Typography>
      )}
    </div>
  );
}
